import React from 'react'

import Button from 'components/Btn'

import type { Slide } from '../validation'
import { Image } from './Image'
import { SlideBg } from './SlideBg'
import { Content, Description, Subtitle, Title } from './styles'

interface Props {
  slide: Slide
}

export function Slide({ slide: { title, button, description, urls, media } }: Props) {
  const url = Object.values(urls).find(Boolean)

  return (
    <SlideBg media={media}>
      <Content>
        <Description>
          <div>
            <Title>{title}</Title>
            <Subtitle>{description}</Subtitle>
            <Button
              to={url}
              primary
            >
              {button}
            </Button>
          </div>
        </Description>
        <Image media={media} />
      </Content>
    </SlideBg>
  )
}
